<template>
  <div class="page-content" style="padding-top: 4rem">
    <div class="container-fluid">
      <InfoCard :infoData="this.infoDetails" :loading="this.loading" />

      <div class="row">
        <div class="col-lg-12">
          <div class="card" id="orderList">
            <div class="card-header border-0">
              <div class="d-flex align-items-center" style="text-align: left">
                <h5 class="card-title mb-0 flex-grow-1">All Coupons</h5>
                <div class="flex-shrink-0">
                  <button
                    @click="addCoupon"
                    type="button"
                    class="btn btn-success add-btn"
                  >
                    <i class="ri-add-line align-bottom me-1"></i>
                    Add Coupan
                  </button>
                  &nbsp;&nbsp;
                  <button
                    type="button"
                    class="btn btn-info"
                    @click="exportCoupansFromList"
                  >
                    <i class="ri-download-line align-bottom me-1"></i> Export
                  </button>
                </div>
              </div>
            </div>
            <div
              class="card-body border border-dashed border-end-0 border-start-0"
            >
              <div class="row g-3">
                <div class="col-xxl-5 col-sm-6">
                  <div class="search-box">
                    <input
                      type="text"
                      class="form-control search"
                      placeholder="Enter Coupon Code"
                      v-model="search_key"
                      @keydown.enter.prevent
                      @input="fetchList(1)"
                    />
                    <i class="ri-search-line search-icon"></i>
                  </div>
                </div>
                <div class="col-xxl-2 col-sm-4">
                  <div>
                    <select
                      class="form-control"
                      v-model="search_status"
                      v-on:change="fetchList(1)"
                      name="choices-single-default"
                      id="idStatus"
                    >
                      <option
                        v-for="(option, index) in filterOptions"
                        :key="index"
                        :value="option.value"
                      >
                        {{ option.label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div
                  class="col-xxl-2 col-sm-4"
                  v-if="ldata != null && ldata.role == 'superadmin'"
                >
                  <div>
                    <select
                      class="form-control"
                      v-model="sort_by"
                      v-on:change="fetchList(1)"
                      name="choices-single-default"
                      id="idStatus"
                    >
                      <option
                        v-for="(option, index) in sortOptions"
                        :key="index"
                        :value="option.value"
                      >
                        {{ option.label }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body pt-0">
              <div>
                <br />
                <br />
                <div class="table-responsive table-card mb-1">
                  <div class="noresult" v-if="loading">
                    <rb-loading-table />
                  </div>
                  <div v-else>
                    <rb-data-table
                      :ldata="ldata"
                      :headers="headers"
                      :tableData="formattedCoupons"
                      @edit="editCoupon"
                      @delete="openDeleteDialog"
                      @update-status="updateCouponStatus"
                    />
                  </div>
                </div>
                <div class="d-flex justify-content-end" v-if="!loading">
                  <div class="me-3">
                    <select
                      class="form-select w-auto"
                      v-model="limitProxy"
                      @change="fetchList(1)"
                    >
                      <template
                        v-for="(role, index) in paginationOptions"
                        :key="index"
                      >
                        <option :value="role">{{ role }}</option>
                      </template>
                    </select>
                  </div>
                  <div
                    class="pagination-wrap hstack gap-2"
                    style="display: flex"
                  >
                    <a
                      class="page-item pagination-prev px-4"
                      v-if="pageNo > 1"
                      @click="fetchList(pageNo - 1)"
                      href="javascript:void(0)"
                    >
                      <i class="ri-arrow-left-line"></i>
                    </a>
                    <ul
                      class="pagination listjs-pagination mb-0"
                      v-if="coupons.length > 0"
                    >
                      <li class="active">
                        <a class="page" href="javascript:void(0)">{{
                          pageNo
                        }}</a>
                      </li>
                      <li>
                        <a
                          v-if="coupons.length >= limit"
                          class="page"
                          href="javascript:void(0)"
                          @click="fetchList(pageNo + 1)"
                          >{{ pageNo + 1 }}</a
                        >
                      </li>
                    </ul>
                    <a
                      v-if="coupons.length >= limit"
                      class="page-item pagination-next px-4"
                      href="javascript:void(0)"
                      @click="fetchList(pageNo + 1)"
                    >
                      <i class="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DeleteDialog
        title="Delete Coupon ?"
        ref="deleteDialog"
        @confirm="deleteCoupon"
      />
      <loaderLoading v-if="overallLoading" />
      <ToastNotification ref="toast" />
    </div>
  </div>
</template>

<script>
import { getAllCoupans, getCoupanById, deleteCoupan } from "@/apis/coupon";
import { updateCoupan } from "@/apis/coupon";
import listMixin from "@/mixins/listMixin";
import { couponHeaders } from "@/constants/headers";
import { couponInfoDetails } from "@/constants/infodetails";
import { couponFilterOptions } from "@/constants/filter";
import { couponSortOptions } from "@/constants/sort";
export default {
  name: "couponList",
  mixins: [listMixin],

  data() {
    return {
      coupons: [],
      search_status: "all",
      sort_by: "",
      search_key: "",

      filterOptions: couponFilterOptions,
      sortOptions: couponSortOptions,
      headers: couponHeaders,
      infoDetails: couponInfoDetails,
    };
  },
  methods: {
    async exportCoupansFromList() {
      const fields = [
        "couponCode",
        "createdAt",
        "createdBy",
        "couponType",
        "discount",
        "validDays",
        "minimumFare",
        "userCount",
        "status",
      ];
      this.$exportCsv(this.formattedCoupons, "coupon.csv", fields);
    },

    async fetchList(pageNo) {
      const response = await this.fetch(pageNo, getAllCoupans, {
        ascending: true,
        status: this.search_status,
        coupan_code: this.search_key,
        sort_by: this.sort_by,
      });

      this.coupons = response.data;
      this.infoDetails[0].count = response?.total_count || 0;
      this.infoDetails[1].count = response?.active_count || 0;
      this.infoDetails[2].count = response?.total_value_Of_coupans_used || 0;

      this.stopLoading();
    },

    async updateCouponStatus(data) {
      await updateCoupan(data.spec_id, data);
    },

    async deleteCoupon(coupon) {
      await this.delete(deleteCoupan, coupon.spec_id);
    },

    addCoupon() {
      this.add("/add_coupan");
    },

    async editCoupon(coupon) {
      await this.update(getCoupanById, coupon.spec_id, "/add_coupan");
    },
  },
  computed: {
    formattedCoupons() {
      return this.coupons.map((coupan) => ({
        id: coupan.id,
        spec_id: coupan.coupan_id,
        couponCode: coupan.coupan_code || "N/A",
        createdAt: coupan.created_at
          ? new Date(coupan.created_at).toLocaleString()
          : "N/A",
        couponType: coupan.coupan_type || "N/A",
        discount:
          coupan.discount_value !== undefined
            ? `${coupan.discount_value}${
                coupan.coupan_type === "percentage" ? "%" : ""
              }`
            : "N/A",
        validDays:
          coupan.valid_day !== undefined ? `${coupan.valid_day} day(s)` : "N/A",
        minimumFare:
          coupan.min_fare !== undefined ? `₹${coupan.min_fare}` : "N/A",
        createdBy: coupan.created_by || "N/A",
        userCount: coupan.used_count,
        status: coupan.is_active ? "Active" : "In Active",
      }));
    },
  },
};
</script>
